import { createActionGroup, props } from '@ngrx/store';
import { HeadProductDto } from '@api/api-service';

/****************** HEAD PRODUCT DETAILS ACTIONS ******************/
export const HeadProductDetailsActions = createActionGroup({
    source: 'HeadProductDetails',
    events: {
        // GET HEAD PRODUCT
        'Get Head Product': props<{ id: number }>(),
        'Get Head Product Success': props<{ response: HeadProductDto }>(),
        'Get Head Product Failure': props<{ error: string }>(),

        // FILTER ACTIONS
        'Set Selected Dimension': props<{ dimension: string | null }>(),
        'Set Selected Option1': props<{ option1: string | null }>(),
        'Set Selected Option2': props<{ option2: string | null }>(),
        'Set Selected Option3': props<{ option3: string | null }>(),

        'Open Product From Variant': props<{ productId: number }>(),
    },
});
